import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import goback from '../assets/img/goback.png';
import borrar from '../assets/img/ICON_ALIADAS/DELETE/DELETE_#37285f.png';
import borrarDM from '../assets/img/ICON_ALIADAS/DELETE/DELETE_WHITE.png';
import download from '../assets/img/ICON_ALIADAS/DOWNLOAD/DOWNLOAD_#37285f.png';
import downloadDM from '../assets/img/ICON_ALIADAS/DOWNLOAD/DOWNLOAD_WHITE.png';
import edit from '../assets/img/ICON_ALIADAS/EDIT/EDIT_#37285f.png';
import editDM from '../assets/img/ICON_ALIADAS/EDIT/EDIT_WHITE.png';
import questionIcon from "../assets/img/ICON_ALIADAS/FAQ/FAQ_#37285f.png";
import questionIconDM from "../assets/img/ICON_ALIADAS/FAQ/FAQ_WHITE.png";
import folderIcon from "../assets/img/ICON_ALIADAS/FOLDER/FOLDER-#37285f.png";
import folderIconDM from "../assets/img/ICON_ALIADAS/FOLDER/FOLDER_WHITE.png";
import moonIcon from "../assets/img/ICON_ALIADAS/MOON/MOON_WHITE.png";
import logoutIcon from "../assets/img/ICON_ALIADAS/SETTINGS/SETTINGS_#37285f.png";
import logoutIconDM from "../assets/img/ICON_ALIADAS/SETTINGS/SETTINGS_WHITE.png";
import sunIcon from "../assets/img/ICON_ALIADAS/SUN/SUN_#37285f.png";
import switchleft from "../assets/img/ICON_ALIADAS/SWITCH/SWITCH_LEFT.png";
import switchright from "../assets/img/ICON_ALIADAS/SWITCH/SWITCH_RIGHT.png";
import logo_dia from "../assets/img/logo_fondotransparente_horizontal_Mesa de trabajo 1_Mesa de trabajo 1_Mesa de trabajo 1.png";
import logo_noche from "../assets/img/logo_fondotransparente_horizontal_Mesa de trabajo 1_Mesa de trabajo 1_Mesa de trabajo 2.png";
import odpIcon from "../assets/img/ICON_ALIADAS/ODP/ODP_PURLPLE.png";
import odpIconDM from "../assets/img/ICON_ALIADAS/ODP/ODP_WHITE.png";

import odsIcon from "../assets/img/ICON_ALIADAS/ODS/ODS_PRUPLE.png";
import odsIconDM from "../assets/img/ICON_ALIADAS/ODS/ODS_WHITE.png";


import odtIcon from "../assets/img/ICON_ALIADAS/ODT/ODT_PURPLE.png";
import odtIconDM from "../assets/img/ICON_ALIADAS/ODT/ODT_WHITE.png";

import pdfIcon from "../assets/img/ICON_ALIADAS/PDF/PDF_#37285f.png";
import pdfIconDM from "../assets/img/ICON_ALIADAS/PDF/PDF_WHITE.png";

import pictureIcon from "../assets/img/ICON_ALIADAS/PICTURE/PICTURE_#37285f.png";
import pictureIconDM from "../assets/img/ICON_ALIADAS/PICTURE/PICTURE_WHITE.png";

import docIcon from "../assets/img/ICON_ALIADAS/DOC/DOC_37285F.png";
import docIconDM from "../assets/img/ICON_ALIADAS/DOC/DOC_WHITE.png";

import xmlIcon from "../assets/img/ICON_ALIADAS/XML/XML_37285F.png";
import xmlIconDM from "../assets/img/ICON_ALIADAS/XML/XML_WHITE.png";

import shareIcon from "../assets/img/ICON_ALIADAS/SHARE/SHARE_37285F.png"
import shareIconDM from "../assets/img/ICON_ALIADAS/SHARE/SHARE_WHITE.png"

import { default as lupaIcon, default as lupaIconDM } from "../assets/img/lupa.png";
import dashboard from "../styles/dashboard.module.css";
import "../styles/global.css";
import { FileItem, FileWithFlag, FolderItem, FolderWithFlag, Item, ModalType, UsuarioShow } from "../utils/Types";
import { URL_SERVER } from "../utils/Utils";
import { useTheme } from "../context/AppThemeContext";
import { Claims } from "../security/ProtectedRouteAdmin";
import { useJwt } from "react-jwt";
import secureLocalStorage from "react-secure-storage";

export const useDashboardFolder = () => {
  const [nameSearch, setNameSearch] = useState<string>("");
  const [files, setFiles] = useState<FileItem[]>([]);
  const [folders, setFolders] = useState<FolderItem[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [viewMode, setViewMode] = useState<"list" | "grid">("list");
  const [openMenuKey, setOpenMenuKey] = useState<string | null>(null);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showShareModal, setshowShareModal] = useState<boolean>(false);
  const [shareFile, setshareFile] = useState<string>("");
  const [shareEmail, setshareEmail] = useState("");
  const [editName, setEditName] = useState("");
  const [editItemId, setEditItemId] = useState<string>("");
  const [editIsFolder, setEditIsFolder] = useState<boolean>(false);
  const [folderViewName, setFolderViewName] = useState<string>("");
  const [searchUser, setSearchUser] = useState<UsuarioShow | null>(null);

  const { folderId } = useParams<{ folderId: string }>();

  const [shareMessage, setShareMessage] = useState<string>("");

  const navigate = useNavigate();

  const { isNight, toggleNightMode } = useTheme();

  const token = typeof secureLocalStorage.getItem("token") === "string"
    ? (secureLocalStorage.getItem("token") as string)
    : null;

  const { decodedToken } = useJwt<Claims>(token || "");
  const isAdmin = decodedToken?.role.name === "ROLE_ADMIN";

  const pdfActual = isNight ? pdfIcon : pdfIcon;
  const odtActual = isNight ? odtIcon : odtIcon;
  const odsActual = isNight ? odsIcon : odsIcon;
  const odpActual = isNight ? odpIcon : odpIcon;
  const pictureActual = isNight ? pictureIcon : pictureIcon;
  const docActual = isNight ? docIcon : docIcon;
  const xmlActual = isNight ? xmlIcon : xmlIcon;
  const shareActual = isNight ? shareIcon : shareIconDM;
  const questionMosaic = questionIcon;

  useEffect(() => {
    if (!folderId) {
      navigate("/dashboard");
    } else {
      fetchData();
    }
  }, [folderId]);

  const fetchData = async () => {
    if (!folderId) return;
    try {
      const response = await axios.get(`${URL_SERVER}/v2/folders/${folderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setFolderViewName(response.data.data.name);
      setFiles(response.data.data.files.map((f: any) => ({
        id: String(f.id),
        name: String(f.name),
        type: String(f.type),
        creation_date: f.creation_date,
        last_update_date: f.last_update_date,
      })));

      setFolders(response.data.data.folders.map((f: any) => ({
        id: String(f.id),
        name: String(f.name),
        creation_date: f.creation_date,
        last_update_date: f.last_update_date,
      })));
    } catch (err) {
      console.error("Error al obtener datos de la carpeta:", err);
    }
  };

  const handleFolderClick = (id: string) => {
    navigate(`/dashboardfolder/${id}`);
  };

  const toggleItemMenu = (key: string) => {
    setOpenMenuKey(prev => (prev === key ? null : key));
  };

  const handleDownload = async (fileId: string, fileName: string) => {
    try {
      const resp = await fetch(`${URL_SERVER}/v2/files/${fileId}/download`, {
        headers: { Authorization: `Bearer ${token}`, Accept: "*/*" },
      });
      if (!resp.ok) throw new Error("Error al descargar");
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Error descarga:", e);
    }
  };

  const handleDelete = async (key: string, isFolder: boolean) => {
    try {
      await axios.delete(`${URL_SERVER}/v2/${isFolder ? "folders" : "files"}/${key}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (err) {
      console.error("Error al eliminar:", err);
    }
    await fetchData();
    setOpenMenuKey(null);
  };

  const handleEdit = (key: string, isFolder: boolean, name: string) => {
    setEditItemId(key);
    setEditIsFolder(isFolder);
    setEditName(name);
    setShowEditModal(true);
    setOpenMenuKey(null);
  };

  const goBack = () => navigate(-1);

  const getFileIcon = (type: string): string => {
    if (type === "application/pdf") return pdfActual;
    if (type === "application/vnd.oasis.opendocument.text") return odtActual;
    if (type === "application/vnd.oasis.opendocument.spreadsheet") return odsActual;
    if (type === "application/vnd.oasis.opendocument.presentation") return odpActual;
    if (type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return docActual;
    if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return xmlActual;
    if (type === "text/plain") return docActual;
    if (type.startsWith("image/")) return pictureActual;
    return questionMosaic;
  };

  const allItems: Item[] = [
    ...folders.map(folder => ({ ...folder, isFolder: true } as FolderWithFlag)),
    ...files.map(file => ({ ...file, isFolder: false } as FileWithFlag)),
  ];

  const goToAdmin = () => {
    navigate("/admin");
    navigate(0);
  };

  useEffect(() => {
    if (!folderId) {
      navigate("/dashboard");
      return;
    }
    fetchData();
  }, [folderId]);

  const closeShareModal = () =>{
    setEditItemId("");
    setShareMessage("");
    setshareEmail("");
    setSearchUser(null);
    setshowShareModal(false);
  }

  const handleShare = (key: string, isFolder: boolean) => {
    setEditItemId(key);
    setEditIsFolder(isFolder);
    setshowShareModal(true);
  }

  const searchUserForShare = async (email: string) => {
    try {

      const response = await axios.get(`${URL_SERVER}/v2/users/email/${email}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );


      if (response.data.data) {
        setSearchUser(response.data.data);
      }

    } catch (error) {
      console.error(error);
    }
  }

  const updateShare = async (itemId: string, isFolder: boolean, user: UsuarioShow) => {

    let dbItem;

    try {
      const response = await axios.get(`${URL_SERVER}/v2/${isFolder ? 'folders' : 'files'}/${itemId}`,
        { headers: { Authorization: `Bearer ${token}` } },

      );

      if (response.data.data) {
        dbItem = response.data.data;
      }

    } catch (error) {
      console.error(error);
    }


    try {

      let payload;

      if (isFolder) {
        payload = {
          foldersUsers: [user.id]
        }
      } else {
        payload = {
          filesUsers: [user.id]
        }
      }

      const response = await axios.put(`${URL_SERVER}/v2/${isFolder ? 'folders' : 'files'}/access/${itemId}`, payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      console.log(response.data);


      if (response.data) {
        setShareMessage("Exitosamente compartido con " + user.name + " " + user.surename);
      } else {
        setShareMessage("No se ha podido compartir con " + user.name + " " + user.surename);
      }

    } catch (error) {
      console.error(error);
    }
  }


  return {
    nameSearch, setNameSearch,
    files, folders,
    showModal, setShowModal,
    newFolderName, setNewFolderName,
    showPolicyModal, setShowPolicyModal,
    sidebarOpen, setSidebarOpen,
    showOptions, setShowOptions,
    viewMode, setViewMode,
    openMenuKey, setOpenMenuKey,
    showUploadFileModal, setShowUploadFileModal,
    selectedFile, setSelectedFile,
    showEditModal, setShowEditModal,
    editName, setEditName,
    editItemId, setEditItemId,
    editIsFolder, setEditIsFolder,
    isNight, toggleNightMode,
    showShareModal, setshowShareModal,
    shareFile, setshareFile,
    shareEmail, setshareEmail,
    shareMessage, setShareMessage,
    searchUser, setSearchUser,
    isAdmin,
    handleShare,
    searchUserForShare,
    updateShare,
    closeShareModal,
    handleFolderClick,
    fetchData,
    toggleItemMenu,
    handleDownload,
    handleDelete,
    handleEdit,
    goBack,
    getFileIcon,
    allItems,
    folderId,
    goToAdmin,
    navigate,
    token,
    folderViewName
  };
};
